module.exports = __webpack_public_path__ + "img/collection-weddingRingsHammered@2x.f9965f6.jpg";